import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/Authcontext';

function CurrentUser() {
    
    const { logout , isAuthenticated , user } = useAuth()
    const [username , setuserName] = useState(null)

    const navigate = useNavigate()
    const handleLogout = () => {

        logout();
        navigate('/')

    }


    useEffect(() => {

        if(localStorage.getItem('user_name')){

            setuserName(localStorage.getItem('user_name'))

        }


    },[])


    if(isAuthenticated){


        return (
            <div className='row mb-2'>
                    <div className="col-auto d-flex align-items-center justify-content-center">
                        {/* <img className='rounded-circle' width={50} src={authorization.user.profile.profilePicturePath ? `${process.env.REACT_APP_MEDIA_HOST}/${authorization.user.profile.profilePicturePath}` : '/images/horse_image_default.jpg'} alt=''/> */}
                    </div>
                    <div className="col ps-0">
                         <h5>{username && username}</h5> 
                        <button className="p-0 btn btn-link text-white" onClick={handleLogout}>Logout</button>
                    </div>
            </div>
        );
    }

    return null;
    // const authorization = useContext(AuthorizationContext);

    // if (authorization.user.profile) {

    // }

    // return (
    //     <div></div>
    // )
}

export default CurrentUser;